export const theme = {
  accentColor: "#ff9800",
  secondColor: "white",
  thirdColor: "black",
};
